// Shared v2 tokens. Everything premium/editorial lives here.
export const V2_COLORS = {
  ink:        '#07070C',   // primary bg — kept from DNA
  inkSoft:    '#0F0F16',   // raised card on dark
  paper:      '#F5F1E8',   // editorial cream — NEW
  paperCream: '#EBE5D4',   // slightly deeper for panels — NEW
  paperInk:   '#1A1A22',   // headings on cream
  warm:       '#E85D2F',   // burnt-orange accent — NEW (used sparingly)
  green:      '#34D399',   // signal / growth / success — kept
  brand1:     '#3B4DFF',
  brand2:     '#7B3DFF',
  brand3:     '#C939FF',
  muted:      '#9C978A',   // muted labels on cream
  mutedDark:  '#B8B4A6',   // muted labels on ink
};

export const V2_TYPE = {
  display: 'Fraunces, "Times New Roman", serif',
  ui:      'Inter, -apple-system, "Segoe UI", Roboto, sans-serif',
  mono:    '"JetBrains Mono", "SFMono-Regular", Menlo, monospace',
};

export const V2_MOTION = [
  {
    name: 'Reveal',
    desc: 'Sections fade + rise 24px on 30% viewport entry. 700ms, cubic-bezier(0.22, 1, 0.36, 1). Never bounces, never overshoots.',
    spec: '700ms · ease-out expo · once',
  },
  {
    name: 'Parallax',
    desc: 'The hero drifts −60px as you scroll the first viewport. Case-study frames shift 20-40px at their own pace. Depth without dizziness.',
    spec: '−60px · −20px · scroll-linked',
  },
  {
    name: 'Hover',
    desc: 'Work tiles compress 1%. CTAs invert. Type reveals with a 200ms ease-out — never on all properties.',
    spec: '0.99 scale · 200ms · specific props',
  },
];
